import config from "@/config";
import http from "@/utils/request";

export default {
  commission:{
    list: {
      url: `${config.API_URL}/api/ly/commission/feedback/page`,
      name: "获取佣金问题反馈列表",
      get: async function (data = {}, config = {}) {
        return await http.get(this.url, data, config);
      },
    },
    handle: {
      url: `${config.API_URL}/api/ly/commission/feedback/handle`,
      name: "佣金问题反馈处理",
      post: async function (data = {}, config = {}) {
        return await http.post(this.url, data, config);
      },
    },
    detail: {
      url: `${config.API_URL}/api/ly/commission/feedback/detail`,
      name: "查看佣金反馈详情",
      get: async function (data = {}) {
        return await http.get(`${this.url}/${data}`);
      },
    },
    page: {
      url: `${config.API_URL}/api/ly/commission/offset/page`,
      name: "获取佣金偏移列表",
      get: async function (data = {}, config = {}) {
        return await http.get(this.url, data, config);
      },
    },

  },
  feedback:{
    list: {
      url: `${config.API_URL}/api/ly/feedback/page`,
      name: "问题反馈列表",
      get: async function (data = {}, config = {}) {
        return await http.get(this.url, data, config);
      },
    },
    detail: {
      url: `${config.API_URL}/api/ly/feedback/detail`,
      name: "查看详情",
      get: async function (data = {}) {
        return await http.get(`${this.url}/${data}`);
      },
    },
    add: {
      url: `${config.API_URL}/admin/feed_back/addFeedBack`,
      name: "新增问题反馈",
      post: async function (data = {}, config = {}) {
        return await http.post(this.url, data, config);
      },
    },
    process: {
      url: `${config.API_URL}/api/ly/feedback/process`,
      name: "处理问题",
      post: async function (data = {}, config = {}) {
        return await http.post(this.url, data, config);
      },
    },
    log: {
      url: `${config.API_URL}/api/ly/feedback/getHandlingInstructions`,
      name: "处理说明",
      get: async function (data = {}) {
        return await http.get(`${this.url}/${data}`);
      },
    },
  },
  dictionary:{
    list: {
      url: `${config.API_URL}/api/ly/feedback/data/dictionary/page`,
      name: "问题反馈数据字典列表",
      get: async function (data = {}, config = {}) {
        return await http.get(this.url, data, config);
      },
    },
    update: {
      url: `${config.API_URL}/api/ly/feedback/data/dictionary/update`,
      name: "更新数据字典",
      put: async function (data = {}, config = {}) {
        return await http.put(this.url, data, config);
      },
    },
    save: {
      url: `${config.API_URL}/api/ly/feedback/data/dictionary/save`,
      name: "新增数据字典",
      post: async function (data = {}, config = {}) {
        return await http.post(this.url, data, config);
      },
    },
    getParentList: {
      url: `${config.API_URL}/api/ly/feedback/data/dictionary/getParentList`,
      name: "获取所有字典父级",
      get: async function (data = {}, config = {}) {
        return await http.get(this.url, data, config);
      },
    },
    detail: {
      url: `${config.API_URL}/api/ly/feedback/data/dictionary/detail`,
      name: "获取数据字典详情",
      get: async function (data = {}) {
        return await http.get(`${this.url}/${data}`);
      },
    },
    getChildList: {
      url: `${config.API_URL}/api/ly/feedback/data/dictionary/getChildList`,
      name: "获取字典子级",
      get: async function (data = {}) {
        return await http.get(`${this.url}/${data}`);
      },
    },
    delete: {
      url: `${config.API_URL}/api/ly/feedback/data/dictionary/delete`,
      name: "删除数据字典",
      delete: async function (data = {}) {
        return await http.delete(`${this.url}/${data}`);
      },
    },
  }
  

};
